import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function UsersRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Users />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Users />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Users />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.User match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.User />
            </Route>
        </Switch>
    );
}

